import React from 'react';

import {ContentDispatch} from 'framework';
import Contexts from 'componentLibrary/contexts';

const {SubmitContext} = Contexts;
export class SubmitContextReceiver extends React.Component {
  static contextType = SubmitContext;

  render() {
    const {config} = this.props;

    return (
      <React.Fragment>
        {_.map(config.contents, (config, ind) => (
          <React.Fragment key={config.id || config.type + ind}>
            <ContentDispatch
              {...this.props}
              handleSubmit={_.get(this.context, 'handleSubmit')}
              handlePostSubmit={_.get(this.context, 'handlePostSubmit')}
              handleSubmissionLock={_.get(this.context, 'handleSubmissionLock')}
              handleSubmissionUnlock={_.get(this.context, 'handleSubmissionUnlock')}
              config={config}
            />
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }
}

export default SubmitContextReceiver;
